import React, {useRef} from "react";
import {useLocation, useNavigate} from "react-router-dom";
import {BtnIcon} from "../../../../../components/BtnIcon";
import {BtnIconFilterWrapper} from "../../../../../components/BtnIconFilterWrapper";
import {DiamondTextIcon} from "../../../../../components/DiamondTextIcon";
import {IdDiamondDown} from "../../../../../components/IdDiamondDown";
import {MainMenu} from "../../../../../components/MainMenu";
import {Movements} from "../../../../../components/Movements";
import {OrientationWrapper} from "../../../../../components/OrientationWrapper";
import {Section} from "../../../../../components/Section";
import {StatusOnWrapper} from "../../../../../components/StatusOnWrapper";
import {Subsection} from "../../../../../components/Subsection";
import {BtnIconActivity1} from "../../../../../icons/BtnIconActivity1";
import {BtnIconClose1} from "../../../../../icons/BtnIconClose1";
import {BtnIconEyeOff1} from "../../../../../icons/BtnIconEyeOff1";
import {BtnIconMenu1} from "../../../../../icons/BtnIconMenu1";
import {BtnIconSearch} from "../../../../../icons/BtnIconSearch";
import {BtnIconSettings2} from "../../../../../icons/BtnIconSettings2";
import {IdDiamondCar1} from "../../../../../icons/IdDiamondCar1";
import {IdDiamondCard1} from "../../../../../icons/IdDiamondCard1";
import useDynamicColors from "../../../../../hooks/useDynamicColors";
import "./style.css";

export const PixieLanding = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const colors = useDynamicColors();

  const handleButtonClick = () => {
    const currentParams = location.search;
    navigate(`/vxlab-card_details-pixie-mobile${currentParams}`);
  };

  const scrollRef = useRef(null);
  return (
      <div className="pixie-landing" ref={scrollRef}>
        <div className="div-17">
          <div className="overlap-25">
            <div className="rectangle-32" />

            <div className="frame-142">
              <div className="account-balance">
                <div className="frame-143">
                  <div className="quick-pay-main">
                    <div className="text-wrapper-127">
                      Balance (USD) | ****2357
                    </div>

                    <div className="frame-144">
                      <BtnIconEyeOff1
                          className="btn-icon-chevron-2"
                          color={colors.secundario}
                      />
                      <div className="text-wrapper-128">$13,000.23</div>

                      <svg
                          width={25}
                          height={25}
                          viewBox="0 0 25 25"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                            d="M9 19L16 13L9 7"
                            stroke={colors.secundario}
                            strokeWidth={2}
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                      </svg>
                    </div>

                    <div className="line-2" />

                    <div className="frame-145">
                      <DiamondTextIcon
                          btnDiamondIconBtnIconAdd6Color={colors.secundario}
                          className="diamond-text-icon-instance"
                          label="Add money"
                          orientation="horizontal"
                          textClassName="diamond-text-icon-2"
                      />
                      <DiamondTextIcon
                          btnDiamondIconIcon={
                            <BtnIconActivity1 className="icon-instance-node-4" />
                          }
                          className="diamond-text-icon-3"
                          label="View activity"
                          orientation="horizontal"
                          textClassName="diamond-text-icon-2"
                      />
                    </div>
                  </div>
                  {/*
                <div className="quick-pay-main-2">
                  <div className="frame-146">
                    <div className="text-wrapper-129">My Goals</div>

                    <div className="frame-147">
                      <div className="text-wrapper-130">New iPhone</div>

                      <img
                        className="btn-icon-chevron-3"
                        alt="Btn icon chevron"
                        src="/img/btn-icon-chevron-17.svg"
                      />
                    </div>
                  </div>

                  <div className="frame-148">
                    <div className="frame-149">
                      <p className="element-10">
                        <span className="text-wrapper-131">$700.54</span>

                        <span className="text-wrapper-132"> / </span>

                        <span className="text-wrapper-133">$950</span>
                      </p>

                      <div className="group-36">
                        <div className="overlap-group-26">
                          <div className="text-7" />

                          <div className="text-8" />
                        </div>
                      </div>
                    </div>

                    <div className="group-37">
                      <div className="overlap-26">
                        <div className="ellipse-19" />

                        <img
                          className="star-2"
                          alt="Star"
                          src="/img/star-1-1.svg"
                        />

                        <img
                          className="vector-10"
                          alt="Vector"
                          src="/img/vector-9.svg"
                        />
                      </div>
                    </div>
                  </div>

                  <img className="line-2" alt="Line" src="/img/line-87.svg" />

                  <div className="frame-145">
                    <DiamondTextIcon
                      btnDiamondIconIcon={
                        <BtnIconAdd6
                          className="icon-instance-node-4"
                          color="var(--secundario)"
                        />
                      }
                      className="diamond-text-icon-instance"
                      label="Add money"
                      orientation="horizontal"
                      textClassName="diamond-text-icon-2"
                    />
                    <div className="diamond-text-icon-4">
                      <div className="btn-diamond-icon-2">
                        <div className="overlap-group-27">
                          <div className="rectangle-33" />

                          <img
                            className="gift"
                            alt="Gift"
                            src="/img/gift.svg"
                          />
                        </div>
                      </div>

                      <div className="text-9">Give as Giftcard</div>
                    </div>
                  </div>
                </div> */}
                  {/*
                <div className="quick-pay-main-2">
                  <div className="frame-146">
                    <div className="text-wrapper-129">My Goals</div>

                    <div className="frame-147">
                      <div className="text-wrapper-134">Europe travel</div>

                      <img
                        className="btn-icon-chevron-3"
                        alt="Btn icon chevron"
                        src="/img/btn-icon-chevron-18.svg"
                      />
                    </div>
                  </div>

                  <div className="frame-148">
                    <div className="frame-149">
                      <p className="element-10">
                        <span className="text-wrapper-131">$8,700</span>

                        <span className="text-wrapper-132">&nbsp;</span>

                        <span className="text-wrapper-133">/ $45,000</span>
                      </p>

                      <div className="group-36">
                        <div className="overlap-group-26">
                          <div className="text-7" />

                          <div className="text-10" />
                        </div>
                      </div>
                    </div>

                    <div className="group-37">
                      <div className="overlap-26">
                        <div className="ellipse-19" />

                        <img
                          className="star-2"
                          alt="Star"
                          src="/img/star-1-1.svg"
                        />

                        <img
                          className="vector-10"
                          alt="Vector"
                          src="/img/vector-9.svg"
                        />
                      </div>
                    </div>
                  </div>

                  <img className="line-2" alt="Line" src="/img/line-87.svg" />

                  <div className="frame-145">
                    <DiamondTextIcon
                      btnDiamondIconIcon={
                        <BtnIconAdd6
                          className="icon-instance-node-4"
                          color="var(--secundario)"
                        />
                      }
                      className="diamond-text-icon-instance"
                      label="Add money"
                      orientation="horizontal"
                      textClassName="diamond-text-icon-2"
                    />
                    <div className="diamond-text-icon-4">
                      <div className="btn-diamond-icon-2">
                        <div className="overlap-group-27">
                          <div className="rectangle-33" />

                          <img
                            className="gift"
                            alt="Gift"
                            src="/img/gift.svg"
                          />
                        </div>
                      </div>

                      <div className="text-9">Give as Giftcard</div>
                    </div>
                  </div>
                </div> */}
                </div>

                <div className="img-slider-dots-2">
                  <StatusOnWrapper className="slider-dots-3" status="on" />
                  <StatusOnWrapper className="slider-dots-4" status="off" />
                  <StatusOnWrapper className="slider-dots-4" status="off" />
                </div>
              </div>

              <Section
                  className="section-instance"
                  icon={<BtnIconFilterWrapper />}
                  override={<BtnIconSettings2 className="btn-icon-settings" />}
                  section="MY SHORTCUTS"
                  sectionClassName="section-2"
              />
              <div className="botonera-3">
                <div className="frame-146">
                  <div className="diamond-text-2">
                    <svg
                        width={107}
                        height={108}
                        viewBox="0 0 107 108"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                          d="M10.0919 64.1114C4.62453 58.6441 4.62454 49.7798 10.0919 44.3124L53.3671 1.03721L96.6423 44.3124C102.11 49.7798 102.11 58.6441 96.6423 64.1114L53.3671 107.387L10.0919 64.1114Z"
                          fill="#F2F3F7"
                      />
                      <g clipPath="url(#clip0_2627_1420)">
                        <path
                            d="M72.1035 63.9575C72.1035 73.3263 64.5148 80.915 55.146 80.915C45.7772 80.915 38.1885 73.3263 38.1885 63.9575C38.1885 54.5887 45.7772 47 55.146 47C64.5148 47 72.1035 54.5887 72.1035 63.9575Z"
                            fill={colors.primario}
                        />
                        <path
                            d="M80.2483 53.3717C78.3759 54.9148 75.4164 55.0472 73.474 52.9626L68.652 47.7862C68.0285 49.7898 66.1573 51.2488 63.9514 51.2488H55.3463C54.6933 51.2488 54.4747 51.4982 53.3405 52.372C49.016 56.1419 42.5207 56.1299 38.2093 52.3359L35.0464 49.5514C33.6246 50.3039 31.9644 50.3225 30.5349 49.6083L26.9072 47.795C26.0967 47.3892 25.7687 46.4038 26.1733 45.5933L36.0165 25.9071C36.4222 25.0966 37.4076 24.7686 38.2181 25.1731L41.8458 26.9876C43.634 27.8811 44.6292 29.7054 44.5647 31.5624H63.9513C67.5462 31.5624 70.9815 33.2795 73.1382 36.1558L81.0139 46.6573C82.5417 48.6928 82.3 51.6776 80.2483 53.3717ZM40.378 29.922L38.218 28.8415L29.8415 45.5933L32.0026 46.6739C32.8131 47.0785 33.7973 46.7515 34.2031 45.94L41.1119 32.1224C41.5166 31.312 41.1885 30.3278 40.378 29.922ZM78.389 48.6261L70.5134 38.1246C68.9725 36.0695 66.5193 34.8435 63.9514 34.8435H43.4196L37.272 47.1398L40.3769 49.8729C43.4665 52.5907 48.1257 52.5907 51.2153 49.8729C53.0352 48.2706 54.1671 47.9677 55.3462 47.9677H63.9513C64.8558 47.9677 65.5918 47.2316 65.5918 46.3271C65.5918 45.4227 64.8557 44.6866 63.9513 44.6866H55.5726C54.667 44.6866 53.9321 43.9516 53.9321 43.0461C53.9321 42.1406 54.6671 41.4056 55.5726 41.4056H65.0505C66.4121 41.4056 67.7246 41.9765 68.652 42.9728L75.8747 50.726C76.5353 51.4347 77.548 51.3757 78.1693 50.8321C78.8188 50.2634 78.8889 49.2911 78.389 48.6261Z"
                            fill={colors.terciario}
                        />
                        <path
                            d="M40.378 29.922L38.218 28.8415L29.8415 45.5933L32.0026 46.6739C32.8131 47.0785 33.7973 46.7515 34.2031 45.94L41.1119 32.1224C41.5166 31.312 41.1885 30.3278 40.378 29.922Z"
                            fill={colors.septimo}
                        />
                        <path
                            d="M55.135 58.6953C56.0138 58.6953 56.7288 59.4103 56.7288 60.2891H59.5629C59.5629 58.3431 58.3005 56.6875 56.552 56.0951V53.792H53.7179V56.0951C51.9694 56.6875 50.707 58.3431 50.707 60.2891C50.707 62.7307 52.6934 64.7171 55.135 64.7171C56.0138 64.7171 56.7288 65.432 56.7288 66.3109C56.7288 67.1897 56.0138 67.9047 55.135 67.9047C54.2561 67.9047 53.5412 67.1897 53.5412 66.3109H50.707C50.707 68.2569 51.9694 69.9125 53.7179 70.5049V72.808H56.552V70.5049C58.3005 69.9125 59.5629 68.2569 59.5629 66.3109C59.5629 63.8693 57.5766 61.8829 55.135 61.8829C54.2561 61.8829 53.5412 61.168 53.5412 60.2891C53.5412 59.4103 54.2561 58.6953 55.135 58.6953Z"
                            fill="white"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0_2627_1420">
                          <rect
                              width={56}
                              height={56}
                              fill="white"
                              transform="translate(26 25)"
                          />
                        </clipPath>
                      </defs>
                    </svg>
                    <div className="text-wrapper-135">Send</div>
                  </div>

                  <div className="diamond-text-2">
                    <svg
                        width={107}
                        height={107}
                        viewBox="0 0 107 107"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                          d="M9.91805 63.4893C4.45071 58.022 4.45071 49.1577 9.91805 43.6903L53.1153 0.493134L96.3125 43.6903C101.78 49.1577 101.78 58.022 96.3125 63.4893L53.1153 106.687L9.91805 63.4893Z"
                          fill="#F2F3F7"
                      />
                      <g clipPath="url(#clip0_2627_1430)">
                        <path
                            d="M71.2187 42.9575C71.2187 52.3263 63.63 59.915 54.2612 59.915C44.8924 59.915 37.3037 52.3263 37.3037 42.9575C37.3037 33.5887 44.8924 26 54.2612 26C63.63 26 71.2187 33.5887 71.2187 42.9575Z"
                            fill={colors.primario}
                        />
                        <path
                            d="M79.3635 53.6269C77.4911 52.0837 74.5316 51.9514 72.5892 54.0359L67.7672 59.2123C67.1438 57.2087 65.2725 55.7497 63.0666 55.7497H54.4615C53.8086 55.7497 53.5899 55.5004 52.4557 54.6266C48.1312 50.8566 41.6359 50.8687 37.3245 54.6627L34.1616 57.4471C32.7399 56.6946 31.0797 56.676 29.6501 57.3903L26.0224 59.2036C25.2119 59.6094 24.8839 60.5947 25.2885 61.4052L35.1317 81.0915C35.5375 81.902 36.5228 82.23 37.3333 81.8254L40.961 80.011C42.7492 79.1175 43.7444 77.2931 43.6799 75.4361H63.0665C66.6614 75.4361 70.0967 73.7191 72.2535 70.8427L80.1291 60.3412C81.657 58.3057 81.4153 55.321 79.3635 53.6269ZM39.4932 77.0765L37.3332 78.1571L28.9567 61.4052L31.1178 60.3247C31.9283 59.92 32.9126 60.247 33.3184 61.0586L40.2271 74.8761C40.6318 75.6865 40.3037 76.6708 39.4932 77.0765ZM77.5042 58.3724L69.6287 68.874C68.0877 70.929 65.6345 72.155 63.0666 72.155H42.5348L36.3872 59.8587L39.4921 57.1257C42.5818 54.4078 47.2409 54.4078 50.3305 57.1257C52.1504 58.7279 53.2824 59.0309 54.4614 59.0309H63.0665C63.971 59.0309 64.707 59.767 64.707 60.6714C64.707 61.5758 63.9709 62.3119 63.0665 62.3119H54.6878C53.7822 62.3119 53.0473 63.0469 53.0473 63.9524C53.0473 64.8579 53.7823 65.5929 54.6878 65.5929H64.1657C65.5273 65.5929 66.8398 65.022 67.7672 64.0257L74.9899 56.2725C75.6505 55.5638 76.6632 55.6229 77.2845 56.1665C77.9341 56.7351 78.0042 57.7074 77.5042 58.3724Z"
                            fill={colors.terciario}
                        />
                        <path
                            d="M39.4932 77.0765L37.3332 78.1571L28.9567 61.4052L31.1178 60.3247C31.9283 59.92 32.9126 60.247 33.3184 61.0586L40.2271 74.8761C40.6318 75.6865 40.3037 76.6708 39.4932 77.0765Z"
                            fill={colors.septimo}
                        />
                        <path
                            d="M54.2502 37.6953C55.1291 37.6953 55.844 38.4103 55.844 39.2891H58.6781C58.6781 37.3431 57.4157 35.6875 55.6673 35.0951V32.792H52.8331V35.0951C51.0847 35.6875 49.8223 37.3431 49.8223 39.2891C49.8223 41.7307 51.8086 43.7171 54.2502 43.7171C55.1291 43.7171 55.844 44.432 55.844 45.3109C55.844 46.1897 55.1291 46.9047 54.2502 46.9047C53.3713 46.9047 52.6564 46.1897 52.6564 45.3109H49.8223C49.8223 47.2569 51.0847 48.9125 52.8331 49.5049V51.808H55.6673V49.5049C57.4157 48.9125 58.6781 47.2569 58.6781 45.3109C58.6781 42.8693 56.6918 40.8829 54.2502 40.8829C53.3713 40.8829 52.6564 40.168 52.6564 39.2891C52.6564 38.4103 53.3713 37.6953 54.2502 37.6953Z"
                            fill="white"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0_2627_1430">
                          <rect
                              width={56}
                              height={56}
                              fill="white"
                              transform="translate(25.1152 26)"
                          />
                        </clipPath>
                      </defs>
                    </svg>

                    <div className="text-wrapper-135">Receive</div>
                  </div>

                  <div className="diamond-text-2">
                    <div className="btn-diamond-icon-3">
                      <div className="overlap-group-28">
                        <div className="rectangle-34" />
                        <div className="global">
                          <svg
                              width={50}
                              height={50}
                              viewBox="0 0 50 50"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                          >
                            <g clipPath="url(#clip0_2627_1442)">
                              <path
                                  d="M0.154297 24.6866C0.154297 38.1544 11.146 49.1472 24.6142 49.1482C38.083 49.148 49.0774 38.1549 49.0774 24.6866C49.0774 11.2176 38.0841 0.225098 24.6158 0.225098C11.164 0.225098 0.154297 11.2059 0.154297 24.6866ZM3.02088 24.6866C3.02088 20.3998 4.27664 16.4008 6.43938 13.0378L9.1613 13.7006C9.63935 13.8202 10.0268 14.1479 10.2241 14.5998C10.4213 15.051 10.3974 15.559 10.1587 15.9936C9.12174 17.8815 9.74513 20.3175 11.5777 21.5392L17.7708 25.6679L19.1945 28.5153C19.6795 29.4851 19.4901 30.6517 18.7235 31.4184L17.8691 32.2728C17.3094 32.8325 17.3094 33.74 17.8691 34.2997L19.5793 36.0099C20.0543 36.4849 20.3159 37.1163 20.3159 37.7881C20.3159 40.7005 20.9794 43.5875 22.2331 46.1493C11.4428 44.9597 3.02088 35.7888 3.02088 24.6866ZM21.7586 27.2335L21.2018 26.1199H21.4109C22.8414 26.1199 24.1275 26.9147 24.7672 28.1942C25.8957 30.4511 28.1641 31.8531 30.6875 31.8531H31.7823V33.2864C31.7823 34.4453 31.3281 35.5319 30.5033 36.3463C27.8578 38.9584 25.8793 41.5689 24.5153 44.2571C23.6525 42.2597 23.1825 39.9935 23.1825 37.7883C23.1825 36.3509 22.6228 34.9996 21.6064 33.9832L20.9064 33.2831C22.4158 31.6434 22.7625 29.2412 21.7586 27.2335ZM26.7714 46.1743C27.9934 43.5478 29.8875 40.9828 32.5173 38.3861C33.8919 37.029 34.6489 35.2179 34.6489 33.2864V30.4198C34.6489 29.6282 34.0072 28.9865 33.2156 28.9865H30.6874C29.2568 28.9865 27.9708 28.1917 27.3311 26.9123C26.2027 24.6554 23.9342 23.2533 21.4109 23.2533H19.7685L19.3327 22.3816C18.5604 20.837 19.2608 18.9576 20.9272 18.1028C22.2971 17.4002 23.1825 15.863 23.1825 14.1866V13.2203C23.1825 12.43 23.8255 11.787 24.6158 11.787H26.3452C29.2931 11.787 31.3613 8.87951 30.4187 6.1101L29.6066 3.67494C32.8208 4.43831 35.7588 5.92196 38.2406 7.94558L37.8031 9.25838C37.733 9.4685 37.6133 9.66219 37.4568 9.8187L35.9083 11.3672C35.0962 12.1793 34.6489 13.2592 34.6489 14.4077V16.0869C34.6489 18.4578 36.5778 20.3868 38.9488 20.3868C39.7391 20.3868 40.3821 21.0297 40.3821 21.82V24.0099C40.3821 24.2312 40.3297 24.4529 40.2308 24.6509L39.7411 25.6303C39.0698 26.973 39.1402 28.5369 39.9293 29.8138C40.7186 31.0908 42.0859 31.8521 43.587 31.8521H44.9868C42.254 39.5976 35.2226 45.3328 26.7714 46.1743ZM46.2108 24.6866C46.2108 26.1586 46.0622 27.5965 45.7802 28.9865H43.587C42.8658 28.9865 42.4941 28.5111 42.3677 28.3067C42.2414 28.1024 41.9825 27.5573 42.305 26.9123L42.7948 25.9328C43.0917 25.3389 43.2486 24.6739 43.2486 24.0099V21.82C43.2486 19.4491 41.3197 17.5202 38.9488 17.5202C38.1584 17.5202 37.5155 16.8772 37.5155 16.0869V14.4076C37.5155 14.0247 37.6645 13.6648 37.9352 13.3942L39.4838 11.8458C39.9533 11.3763 40.3125 10.7952 40.5226 10.165L40.5392 10.1152C44.0595 13.9588 46.2108 19.0761 46.2108 24.6866ZM24.6158 3.09168C25.2219 3.09168 25.8219 3.11806 26.4156 3.16727L27.7021 7.02521C28.019 7.95628 27.3284 8.92041 26.3452 8.92041H24.6158C22.2449 8.92041 20.316 10.8493 20.316 13.2202V14.1865C20.316 14.7896 20.0359 15.3384 19.619 15.5523C17.3825 16.6993 16.1096 18.8902 16.1465 21.1399L13.1679 19.1542C12.5628 18.7507 12.3446 17.9686 12.6714 17.3736C13.3414 16.1538 13.4068 14.7246 12.8512 13.4524C12.2952 12.1795 11.2037 11.2564 9.84814 10.9176L8.31021 10.543C12.2726 5.98101 18.1131 3.09168 24.6158 3.09168Z"
                                  fill={colors.terciario}
                              />
                              <path
                                  d="M24.6158 3.09168C25.2219 3.09168 25.8219 3.11806 26.4156 3.16727L27.7021 7.02521C28.019 7.95628 27.3284 8.92041 26.3452 8.92041H24.6158C22.2449 8.92041 20.316 10.8493 20.316 13.2202V14.1865C20.316 14.7896 20.0359 15.3384 19.619 15.5523C17.3825 16.6993 16.1096 18.8902 16.1465 21.1399L13.1679 19.1542C12.5628 18.7507 12.3446 17.9686 12.6714 17.3736C13.3414 16.1538 13.4068 14.7246 12.8512 13.4524C12.2952 12.1795 11.2037 11.2564 9.84814 10.9176L8.31021 10.543C12.2726 5.98101 18.1131 3.09168 24.6158 3.09168Z"
                                  fill={colors.septimo}
                              />
                              <path
                                  d="M21.7586 27.2335L21.2018 26.1199H21.4109C22.8414 26.1199 24.1275 26.9147 24.7672 28.1942C25.8957 30.4511 28.1641 31.8531 30.6875 31.8531H31.7823V33.2864C31.7823 34.4453 31.3281 35.5319 30.5033 36.3463C27.8578 38.9584 25.8793 41.5689 24.5153 44.2571C23.6525 42.2597 23.1825 39.9935 23.1825 37.7883C23.1825 36.3509 22.6228 34.9996 21.6064 33.9832L20.9064 33.2831C22.4158 31.6434 22.7625 29.2412 21.7586 27.2335Z"
                                  fill={colors.septimo}
                              />
                              <path
                                  d="M46.2108 24.6866C46.2108 26.1586 46.0622 27.5965 45.7802 28.9865H43.587C42.8658 28.9865 42.4941 28.5111 42.3677 28.3067C42.2414 28.1024 41.9825 27.5573 42.305 26.9123L42.7948 25.9328C43.0917 25.3389 43.2486 24.6739 43.2486 24.0099V21.82C43.2486 19.4491 41.3197 17.5202 38.9488 17.5202C38.1584 17.5202 37.5155 16.8772 37.5155 16.0869V14.4076C37.5155 14.0247 37.6645 13.6648 37.9352 13.3942L39.4838 11.8458C39.9533 11.3763 40.3125 10.7952 40.5226 10.165L40.5392 10.1152C44.0595 13.9588 46.2108 19.0761 46.2108 24.6866Z"
                                  fill={colors.septimo}
                              />
                            </g>
                            <defs>
                              <clipPath id="clip0_2627_1442">
                                <rect
                                    width={48.9231}
                                    height={48.9231}
                                    fill="white"
                                    transform="translate(0.154297 0.224609)"
                                />
                              </clipPath>
                            </defs>
                          </svg>
                        </div>
                      </div>
                    </div>

                    <div className="text-wrapper-135">Global Transf</div>
                  </div>
                </div>

                <div className="frame-146">
                  <div className="diamond-text-2">
                    <div className="btn-diamond-img-6">
                      <div className="frame-150">
                        <div className="group-38">
                          <div className="overlap-group-29">
                            <div className="ellipse-20" />
                            <div className="goals">
                              <svg
                                  width={44}
                                  height={44}
                                  viewBox="0 0 44 44"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                    d="M43.0276 8.96379C43.1298 9.21109 43.1567 9.48328 43.1049 9.74593C43.0531 10.0086 42.9249 10.2499 42.7365 10.4394L37.3452 15.8544C37.2198 15.98 37.071 16.0796 36.9073 16.1474C36.7435 16.2152 36.5681 16.25 36.391 16.2496H28.8621L25.2149 19.9129C25.626 20.7774 25.7196 21.76 25.4792 22.6871C25.2387 23.6142 24.6797 24.4261 23.9009 24.9792C23.1221 25.5324 22.1737 25.7912 21.2233 25.7099C20.2728 25.6286 19.3816 25.2125 18.7072 24.535C18.0327 23.8576 17.6184 22.9625 17.5375 22.0079C17.4565 21.0533 17.7142 20.1007 18.2649 19.3185C18.8157 18.5362 19.624 17.9748 20.547 17.7332C21.4701 17.4917 22.4484 17.5858 23.3091 17.9987L26.9563 14.3354V6.77343C26.956 6.59554 26.9906 6.41932 27.0581 6.25486C27.1256 6.09041 27.2248 5.94093 27.3498 5.81498L32.7411 0.400003C32.9296 0.210189 33.17 0.0808679 33.4317 0.0284326C33.6935 -0.0240028 33.9649 0.00280972 34.2115 0.105471C34.458 0.208132 34.6687 0.382019 34.8168 0.605087C34.9649 0.828154 35.0436 1.09036 35.0432 1.35845V8.12718H41.7822C42.0489 8.12722 42.3096 8.20674 42.5313 8.35566C42.753 8.50459 42.9257 8.71623 43.0276 8.96379ZM38.5286 10.8347H33.6953C33.3379 10.8347 32.9951 10.692 32.7423 10.4382C32.4895 10.1843 32.3475 9.83996 32.3475 9.48092V4.62639L29.6519 7.33388V13.5422H35.833L38.5286 10.8347ZM42.0707 14.9365C42.7581 17.0538 43.13 19.3172 43.13 21.6646C43.1291 26.2401 41.6855 30.6978 39.0064 34.3983C36.3273 38.0989 32.5503 40.8523 28.217 42.2636C23.8837 43.675 19.2167 43.6718 14.8853 42.2546C10.5539 40.8373 6.78057 38.0788 4.10646 34.3746C1.43236 30.6703 -0.00517258 26.2107 1.39855e-05 21.6352C0.00520055 17.0598 1.45284 12.6035 4.13533 8.90537C6.81783 5.20728 10.5974 2.45739 14.932 1.05005C19.2666 -0.357296 23.9336 -0.3498 28.2637 1.07146L26.0856 3.25911C22.0842 2.26815 17.8698 2.62023 14.0863 4.26156C10.3029 5.90288 7.15852 8.74318 5.13361 12.3485C3.1087 15.9538 2.31463 20.1258 2.87274 24.227C3.43086 28.3283 5.31045 32.1332 8.22433 35.0605C11.1382 37.9878 14.9261 39.8764 19.0093 40.4378C23.0925 40.9991 27.2464 40.2024 30.8363 38.1693C34.4262 36.1362 37.2546 32.9785 38.8895 29.1787C40.5244 25.379 40.8757 21.1461 39.8899 17.1269L42.0707 14.9365ZM34.7736 18.9571C35.3525 21.8083 35.0014 24.7709 33.7722 27.4059C32.5431 30.0409 30.5013 32.2079 27.9496 33.5858C25.3979 34.9637 22.472 35.4791 19.6058 35.0556C16.7395 34.6322 14.0854 33.2923 12.0368 31.2347C9.98826 29.1772 8.6543 26.5114 8.23267 23.6325C7.81104 20.7536 8.32418 17.8149 9.69604 15.252C11.0679 12.689 13.2255 10.6383 15.8489 9.40371C18.4723 8.16914 21.422 7.81645 24.2607 8.39792V11.1758C21.9706 10.5824 19.5499 10.7617 17.3713 11.6861C15.1927 12.6105 13.3772 14.2286 12.2042 16.2913C11.0313 18.3539 10.5661 20.7467 10.8802 23.1011C11.1944 25.4554 12.2705 27.6407 13.9428 29.3204C15.6151 31 17.7908 32.0809 20.1349 32.3964C22.4789 32.712 24.8612 32.2447 26.9148 31.0666C28.9685 29.8885 30.5795 28.0649 31.4998 25.8768C32.4201 23.6886 32.5987 21.2572 32.0079 18.9571H34.7736Z"
                                    fill={colors.terciario}
                                />
                              </svg>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="text-wrapper-135">My Goals</div>
                  </div>

                  <div className="diamond-text-2">
                    <svg
                        width={108}
                        height={108}
                        viewBox="0 0 108 108"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                          d="M10.5919 64.1114C5.12453 58.6441 5.12454 49.7798 10.5919 44.3124L53.8671 1.03721L97.1423 44.3124C102.61 49.7798 102.61 58.6441 97.1423 64.1114L53.8671 107.387L10.5919 64.1114Z"
                          fill="#F2F3F7"
                      />
                      <path
                          d="M52.4909 43.5541L45.6906 50.3543C45.0484 50.9965 44.0189 50.9965 43.3861 50.3543L36.5859 43.5541L43.3861 36.7539C44.0284 36.1116 45.0579 36.1116 45.6906 36.7539L52.4909 43.5541Z"
                          fill={colors.septimo}
                      />
                      <path
                          d="M55.0001 60.4659C61.637 60.4659 67.0129 65.7537 67.0129 72.2818C67.0129 78.8099 61.637 84.0977 55.0001 84.0977C48.3632 84.0977 42.9873 78.8099 42.9873 72.2818C42.9873 65.7537 48.3632 60.4659 55.0001 60.4659Z"
                          fill={colors.primario}
                      />
                      <path
                          d="M74.3946 45.8509C74.3946 46.5119 74.2661 47.18 74.0014 47.8187C73.21 49.7313 71.3679 50.9671 69.3089 50.9671L64.9386 50.9671C63.8166 50.9671 62.9069 50.0578 62.9069 48.9359C62.9069 47.8139 63.8166 46.9042 64.9386 46.9042L69.3089 46.9042C69.9175 46.9042 70.1678 46.4571 70.2476 46.2651C70.3285 46.0695 70.4694 45.5673 70.031 45.1293L56.5406 31.6556C55.746 30.8617 54.453 30.8617 53.6584 31.6556L40.1684 45.1293C39.73 45.5673 39.8705 46.0695 39.9514 46.2647C40.0311 46.4571 40.2819 46.9042 40.8904 46.9042L53.1696 46.9042C55.4099 46.9042 57.2325 48.7268 57.2325 50.9671L57.2325 76.9687C57.2325 78.0907 56.3232 79 55.2012 79C54.0793 79 53.1696 78.0907 53.1696 76.9687L53.1696 50.9671L40.8904 50.9671C38.8314 50.9671 36.989 49.7313 36.1975 47.8187C35.4033 45.8993 35.8349 43.7153 37.2973 42.255L50.7872 28.7813C53.1652 26.4064 57.0341 26.4064 59.4121 28.7813L72.9021 42.255C73.8777 43.2293 74.3942 44.5258 74.3946 45.8509Z"
                          fill={colors.terciario}
                      />
                    </svg>

                    <div className="text-wrapper-135">Top-ups</div>
                  </div>

                  <div className="diamond-text-2">
                    <svg
                        width={107}
                        height={108}
                        viewBox="0 0 107 108"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                          d="M10.0919 64.1114C4.62453 58.6441 4.62454 49.7798 10.0919 44.3124L53.3671 1.03721L96.6423 44.3124C102.11 49.7798 102.11 58.6441 96.6423 64.1114L53.3671 107.387L10.0919 64.1114Z"
                          fill="#F2F3F7"
                      />
                      <path
                          d="M39.5533 49.0437L29.3652 38.8556C28.403 37.8934 28.403 36.351 29.3652 35.403L39.5533 25.2148L49.7415 35.403C50.7037 36.3652 50.7037 37.9075 49.7415 38.8556L39.5533 49.0437Z"
                          fill={colors.septimo}
                      />
                      <path
                          d="M46.3613 53.9658H45.541C44.6349 53.9658 43.9004 54.7003 43.9004 55.6064C43.9004 56.5126 44.6349 57.2471 45.541 57.2471H46.3613C47.2674 57.2471 48.002 56.5126 48.002 55.6064C48.002 54.7003 47.2674 53.9658 46.3613 53.9658Z"
                          fill={colors.primario}
                      />
                      <path
                          d="M62.5215 47.4033H52.1035C51.1974 47.4033 50.4629 48.1378 50.4629 49.0439C50.4629 49.9501 51.1974 50.6846 52.1035 50.6846H62.5215C63.4276 50.6846 64.1621 49.9501 64.1621 49.0439C64.1621 48.1378 63.4276 47.4033 62.5215 47.4033Z"
                          fill={colors.terciario}
                      />
                      <path
                          d="M59.8874 71.9307H43.9004C42.0911 71.9307 40.6191 70.4587 40.6191 68.6494V39.7744C40.6191 37.9651 42.0911 36.4932 43.9004 36.4932H64.071C65.8803 36.4932 67.3522 37.9651 67.3522 39.7744V49.0439C67.3522 49.9501 68.0867 50.6846 68.9928 50.6846C69.899 50.6846 70.6335 49.9501 70.6335 49.0439V39.7744C70.6335 36.1559 67.6895 33.2119 64.071 33.2119H43.9004C40.2818 33.2119 37.3379 36.1559 37.3379 39.7744V68.6494C37.3379 72.268 40.2818 75.2119 43.9004 75.2119H59.8874C60.7935 75.2119 61.528 74.4774 61.528 73.5713C61.528 72.6652 60.7935 71.9307 59.8874 71.9307Z"
                          fill={colors.terciario}
                      />
                      <path
                          d="M46.3613 60.5283H45.541C44.6349 60.5283 43.9004 61.2628 43.9004 62.1689C43.9004 63.0751 44.6349 63.8096 45.541 63.8096H46.3613C47.2674 63.8096 48.002 63.0751 48.002 62.1689C48.002 61.2628 47.2674 60.5283 46.3613 60.5283Z"
                          fill={colors.primario}
                      />
                      <path
                          d="M62.5215 40.8408H52.1035C51.1974 40.8408 50.4629 41.5753 50.4629 42.4814C50.4629 43.3876 51.1974 44.1221 52.1035 44.1221H62.5215C63.4276 44.1221 64.1621 43.3876 64.1621 42.4814C64.1621 41.5753 63.4276 40.8408 62.5215 40.8408Z"
                          fill={colors.terciario}
                      />
                      <path
                          d="M70.0388 62.7394H68.5354C67.8001 62.7394 67.202 62.1306 67.202 61.3822V61.1605C67.202 60.4259 67.7752 59.8721 68.5354 59.8721H69.957C70.3749 59.8721 70.807 60.1518 70.807 60.6199C70.807 61.526 71.5415 62.2605 72.4476 62.2605C73.3537 62.2605 74.0882 61.526 74.0882 60.6199C74.0882 58.6537 72.6363 57.013 70.7233 56.6614V55.6064C70.7233 54.7003 69.9888 53.9658 69.0827 53.9658C68.1766 53.9658 67.4421 54.7003 67.4421 55.6064V56.7178C66.6301 56.9094 65.8863 57.3143 65.2831 57.9046C64.4045 58.7642 63.9207 59.9205 63.9207 61.1605V61.3822C63.9207 63.9398 65.9908 66.0206 68.5354 66.0206H70.0388C70.7789 66.0206 71.3812 66.6203 71.3812 67.3573V68.1366C71.3812 68.8498 70.8041 69.3877 70.0388 69.3877H67.5955C67.133 69.3877 66.7842 69.0566 66.7842 68.6175C66.7842 67.7114 66.0497 66.9769 65.1436 66.9769C64.2374 66.9769 63.5029 67.7114 63.5029 68.6175C63.5029 69.7164 63.9336 70.7419 64.7156 71.5054C65.448 72.2204 66.4112 72.6283 67.4421 72.6653V73.5713C67.4421 74.4774 68.1766 75.2119 69.0827 75.2119C69.9888 75.2119 70.7233 74.4774 70.7233 73.5713V72.6211C72.9801 72.3058 74.6625 70.4496 74.6625 68.1366V67.3573C74.6625 64.811 72.5883 62.7394 70.0388 62.7394Z"
                          fill={colors.primario}
                      />
                      <path
                          d="M59.2402 63.8096C60.1464 63.8096 60.8809 63.0751 60.8809 62.1689C60.8809 61.2628 60.1464 60.5283 59.2402 60.5283H52.1035C51.1974 60.5283 50.4629 61.2628 50.4629 62.1689C50.4629 63.0751 51.1974 63.8096 52.1035 63.8096H59.2402Z"
                          fill={colors.terciario}
                      />
                      <path
                          d="M46.3613 47.4033H45.541C44.6349 47.4033 43.9004 48.1378 43.9004 49.0439C43.9004 49.9501 44.6349 50.6846 45.541 50.6846H46.3613C47.2674 50.6846 48.002 49.9501 48.002 49.0439C48.002 48.1378 47.2674 47.4033 46.3613 47.4033Z"
                          fill={colors.primario}
                      />
                      <path
                          d="M64.1621 55.6064C64.1621 54.7003 63.4276 53.9658 62.5215 53.9658H52.1035C51.1974 53.9658 50.4629 54.7003 50.4629 55.6064C50.4629 56.5126 51.1974 57.2471 52.1035 57.2471H62.5215C63.4276 57.2471 64.1621 56.5126 64.1621 55.6064Z"
                          fill={colors.terciario}
                      />
                      <path
                          d="M46.3613 40.8408H45.541C44.6349 40.8408 43.9004 41.5753 43.9004 42.4814C43.9004 43.3876 44.6349 44.1221 45.541 44.1221H46.3613C47.2674 44.1221 48.002 43.3876 48.002 42.4814C48.002 41.5753 47.2674 40.8408 46.3613 40.8408Z"
                          fill={colors.primario}
                      />
                    </svg>
                    <div className="text-wrapper-135">Pay bills</div>
                  </div>
                </div>
              </div>

              <div className="tarjetas-accion">
                <Subsection
                    subsection="My cards"
                    subsectionClassName="subsection-instance"
                />
                <div className="highlighted-button">
                  <div
                      className="frame-151 highlighted-button"
                      onClick={handleButtonClick}
                  >
                    <div className="credit-card-main">
                      <div className="contenido">
                        <div
                            className="tarjeta"
                            style={{
                              backgroundImage: colors.url_card
                                  ? `url(${colors.url_card})`
                                  : "url(../../../../../../static/img/image-2.png)",
                              backgroundColor: colors.url_card
                                  ? "transparent"
                                  : "#F2F3F7",
                              backgroundSize: "100% 100%",
                            }}
                        >
                          <div className="overlap-group-30">
                            <div className="image-12" />

                            <img
                                className="btn-icon-chevron-4"
                                alt="Btn icon chevron"
                                src="/img/btn-icon-chevron-4.svg"
                            />

                            <div className="frame-152">
                              <div className="text-wrapper-136">GOLD</div>
                              <div className="text-wrapper-137">****5849</div>
                            </div>

                            {/* {colors.url_card ? null : (
                          <img
                            className="logo-visa-7"
                            alt="Logo Visa"
                            src="/img/logo-visa-6.svg"
                          />
                        )} */}
                          </div>
                        </div>
                        <div className="txt">
                          <div className="frame-153">
                            <div className="text-wrapper-138">$ 1,250</div>

                            <div className="text-wrapper-139">Available</div>
                          </div>

                          <div className="frame-154">
                            <div className="text-wrapper-140">Pay date</div>

                            <div className="text-wrapper-141">04/14</div>
                          </div>
                        </div>

                        <OrientationWrapper
                            btnDiamondIconIcon={
                              <BtnIconSearch
                                  className="icon-instance-node-4"
                                  color="white"
                              />
                            }
                            btnDiamondIconRectangleClassName="diamond-text-icon-6"
                            className="diamond-text-icon-5"
                            label="CVV"
                            orientation="vertical"
                            textClassName="diamond-text-icon-7"
                        />
                      </div>
                    </div>

                    {/* <div className="credit-card-main">
                  <div className="contenido">
                    <div className="tarjeta-2">
                      <div className="overlap-group-30">
                        <div className="image-12" />

                        <img
                          className="btn-icon-chevron-4"
                          alt="Btn icon chevron"
                          src="/img/btn-icon-chevron-4.svg"
                        />

                        <div className="frame-152">
                          <div className="text-wrapper-136">SILVER</div>

                          <div className="text-wrapper-137">*****2345</div>
                        </div>

                        <img
                          className="logo-visa-7"
                          alt="Logo visa"
                          src="/img/logo-visa-6.svg"
                        />
                      </div>
                    </div>

                    <div className="txt">
                      <div className="frame-153">
                        <div className="text-wrapper-138">$ 550.00</div>

                        <div className="text-wrapper-139">Available</div>
                      </div>

                      <div className="frame-154">
                        <div className="text-wrapper-140">Pay date</div>

                        <div className="text-wrapper-141">08/22</div>
                      </div>
                    </div>

                    <OrientationWrapper
                      btnDiamondIconIcon={
                        <BtnIconSearch
                          className="icon-instance-node-4"
                          color="white"
                        />
                      }
                      btnDiamondIconRectangleClassName="diamond-text-icon-6"
                      className="diamond-text-icon-5"
                      label="CVV"
                      orientation="vertical"
                      textClassName="diamond-text-icon-7"
                    />
                  </div>
                </div> */}
                  </div>{" "}
                </div>
                {/*
              <div className="img-slider-dots-3">
                <StatusOnWrapper
                  className="design-component-instance-node-3"
                  status="on"
                />
                <StatusOnWrapper
                  className="design-component-instance-node-3"
                  status="off"
                />
                <StatusOnWrapper
                  className="design-component-instance-node-3"
                  status="off"
                />
              </div> */}
              </div>

              <div className="frame-155">
                <div className="latest-transactions">
                  <div className="subsection-6">
                    <div className="frame-156">
                      <div className="subsection-7">Last Transactions</div>
                    </div>

                    <div className="frame-157">
                      <div className="btn-text-link-5">
                        <div className="text-link-3">More</div>

                        <svg
                            width={25}
                            height={25}
                            viewBox="0 0 25 25"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                              d="M9 19L16 13L9 7"
                              stroke={colors.secundario}
                              strokeWidth={2}
                              strokeLinecap="round"
                              strokeLinejoin="round"
                          />
                        </svg>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="latest-transactions-2">
                  <div className="frame-158">
                    <Movements
                        amountClassName="movements-6"
                        className="movements-instance"
                        dateClassName="movements-5"
                        divClassName="movements-2-instance"
                        frameClassName="movements-4"
                        movement="Purchase Starbucks"
                        override={
                          <IdDiamondCard1
                              className="icon-instance-node-5"
                              color={colors.terciario}
                          />
                        }
                        text="- $18.40"
                    />
                    <Movements
                        amountClassName="movements-6"
                        className="movements-instance"
                        dateClassName="movements-5"
                        divClassName="movements-2-instance"
                        frameClassName="movements-7"
                        movement="Purchase Merchant ABC Cash out"
                        override={
                          <IdDiamondCar1
                              className="icon-instance-node-5"
                              color={colors.terciario}
                          />
                        }
                        text="- $90.10"
                    />
                    <Movements
                        className="movements-8"
                        dateClassName="movements-5"
                        divClassName="movements-2-instance"
                        frameClassName="movements-9"
                        movement="Money received from Luz Marina"
                        override={
                          <IdDiamondDown
                              btnIconArrowColor={colors.terciario}
                              className="design-component-instance-node-3"
                              rectangleClassName="id-diamond-down-2"
                          />
                        }
                        text="$600.50"
                    />
                  </div>
                </div>
              </div>

              <div className="banner-promo-small">
                <div className="group-39">
                  <div className="overlap-group-31">
                    <div className="text-wrapper-142">We have great news</div>

                    <div className="text-wrapper-143">Wait our new launch</div>
                  </div>
                </div>

                <BtnIconClose1 className="btn-icon-close" color="white" />
                <img className="like" alt="Like" src="/img/like.svg" />
              </div>
            </div>

            {/* <BtnCheckboxBtn
            className="btn-checkbox-btn-main-qr"
            divClassName="btn-checkbox-btn-instance"
          /> */}
          </div>

          <div className="frame-159">
            <div className="frame-160">
              <img
                  className="ellipse-21"
                  alt="Ellipse"
                  src="/img/ellipse-110.png"
              />

              <p className="nice-to-see-u-mary">
                <span className="text-wrapper-144">Nice to see u </span>

                <span className="text-wrapper-145">Mary!</span>
              </p>
            </div>

            <div className="frame-161">
              <BtnIcon
                  className="btn-icon-menu"
                  divClassName="btn-icon-2"
                  ellipseClassName="btn-icon-notifications-on-instance"
                  overlapGroupClassName="btn-icon-notifications-on"
                  vector="/img/vector-8.svg"
                  vectorClassName="btn-icon-instance"
              />
              <BtnIconMenu1 className="btn-icon-menu" />
            </div>
          </div>

          {/* <div className="navs-statusbar-5">
          <div className="content-7">
            <div className="text-wrapper-146">9:50</div>

            <img className="icons-7" alt="Icons" src="/img/icons.svg" />
          </div>
        </div> */}

          <MainMenu
              btnMenuHomeFluentHome="/img/fluent-home-12-filled-2.svg"
              btnMenuMoreRegularMenuDots="/img/regular-menu-dots-4.svg"
              color={colors.primario}
              btnMenuRequestProfits="/img/profits-1-2.svg"
              btnMenuSendMingcuteSendPlane="/img/mingcute-send-plane-line-2.svg"
              className="main-menu-instance"
          />
        </div>
      </div>
  );
};
